import React, { useState } from "react";
import Popup from "reactjs-popup";
import { groupInfo, dataObject, validate } from "../config/QuotationForm.js";
import FormColumn from "./FormColumn.js";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import { SERVER_URL, USE_OVERLAY } from "../config/config.js";
import LoadingOverlay from "react-loading-overlay";

const QuotationForm = ({ sessionObject }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [mailMessage, setMailMessage] = useState("");

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
  };

  const myForm = useForm("Quotation", validate, {
    ...dataObject,
    ...variablesFromSession,
  });

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    return null;
  };

  const checkDisabledCondition = (fieldInfo) => {
    return "";
  };

  const checkVisibilityCondition = (fieldInfo) => {
    return true;
  };

  const handleSendMail = async () => {
    const { subject, sender_email, receiver_cc } = myForm.pageState;

    if (!subject?.trim() || !sender_email?.trim() || !receiver_cc?.trim()) {
      return;
    }

    try {
      myForm.setOverlay(true);
      setMailMessage("");
      const { from_location, to_location, loading, unloading } =
        myForm.pageState;

      const params = new URLSearchParams({
        subject,
        user_id: sessionObject.sessionVariables.user_id,
        receiver_cc,
        receiver_email: sender_email,
        from_location,
        to_location,
        loading,
        unloading,
      }).toString();

      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("attachments", file));

      const response = await fetch(
        `${SERVER_URL}/mail/send_gmail_with_multiple?${params}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errText = await response.text();
        setMailMessage(`Send mail failed: ${errText}`);
        myForm.setPageMode("error");
        return;
      }

      setMailMessage("Mail sent successfully!");
      myForm.setPageMode("submitted");
    } catch (err) {
      setMailMessage(`Error sending mail: ${err.message}`);
      myForm.setPageMode("error");
    } finally {
      myForm.setOverlay(false);
    }
  };

  return (
    <div className="challan-form-container">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={myForm.overlay}
          spinner
          text="Sending your content..."
          styles={{
            wrapper: {
              overflow: true ? "hidden" : "scroll",
            },
          }}
        ></LoadingOverlay>
      )}
      <div>
        <Popup
          open={myForm.pageMode === "submitted" || myForm.pageMode === "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {myForm.pageMode === "submitted" ? (
                  <div>Success</div>
                ) : (
                  <div>Error</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>

              <div className="pop-up-content">
                {mailMessage ||
                  (myForm.pageMode === "submitted"
                    ? "Mail successfully sent."
                    : `Error: ${myForm.popupError}`)}
              </div>

              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    setSelectedFiles([]);
                    myForm.setPageMode("write");

                    close();
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Quotation</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title"></div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
            <div className="form-row">
              <label className="form-label">Attachments</label>
              <input
                type="file"
                multiple
                onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
                className="form-input"
              />
            </div>

            <></>
          </div>
        </div>
        <div className="form-footer">
          
          <button
            onClick={handleSendMail}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "send_mail")}
          >
            Send Mail
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotationForm;
